/* Product pages (all templates except the drop templates): pins the gallery on desktop while the buy column scrolls.
   A gallery taller than the viewport scrolls along until its last image is in view and pins there. */
(function () {
  var media = document.querySelector('.product--brand:not(.product--limited-drop) .product__media');
  if (!media) return;

  var mq = window.matchMedia('(min-width: 1024px)');
  var gap = 24;
  var setMediaTop = function () {
    if (!mq.matches) {
      media.style.removeProperty('--product-media-top');
      return;
    }
    // The header stays pinned on scroll: use its height even while the page is at the top (--header-height is 0 there).
    var header = document.querySelector('header-wrapper');
    var hh = header && header.dataset.enableStickyHeader === 'true'
      ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-internal')) || 0
      : 0;
    var top = Math.min(hh + gap, window.innerHeight - gap - media.offsetHeight);
    media.style.setProperty('--product-media-top', Math.round(top) + 'px');
  };

  setMediaTop();
  window.addEventListener('resize', setMediaTop);
  window.addEventListener('load', setMediaTop);
  if ('ResizeObserver' in window) new ResizeObserver(setMediaTop).observe(media);
})();
